import Slider from "react-slick";
import toronto from "../images/TORONTO.webp";
import ottawa from "../images/Ottawa-m.webp";
import orlando from "../images/orlando.webp";
import denver from "../images/denver.webp";
import atlanta from "../images/atlanta.webp";
import vancouver from "../images/Vancouver.webp";
import calgary from "../images/Calgary.webp";
import chicago from "../images/Chicago.webp";
import montreal from "../images/Montreal.webp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

const locations = [
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Toronto",
    description: [
      "Explore the 6ix Your Way - Welcome to Toronto, affectionately known as the 6ix. Whether you're here for a high-stakes business meeting in the Financial District, a family reunion in Scarborough, or simply exploring the vibrant neighborhoods of Queen West and Kensington Market, having your own set of wheels makes all the difference. Our car rental Toronto service is designed for the modern traveler.",
      "We offer compact sedans for navigating the city streets with ease, and robust SUV rentals in Toronto perfect for loading up the family for a scenic drive. Forget the hassle of transit schedules—start your engine and discover the city at your own pace.",
    ],
    image: toronto,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Orlando",
    description: [
      "Experience the Magic in the Theme Park Capital - Welcome to Orlando, the Theme Park Capital of the World. Whether you are chasing thrills at Universal Studios, treating the kids to a magical week at Disney, or attending a conference on International Drive, convenience is key. Our car rental Orlando service ensures the fun starts the moment you land.",
      "Choose a spacious minivan to fit the whole family and their luggage, or book a convertible for a sunny drive to the Space Coast beaches. From the attractions to the outlets, skip the shuttle lines and maximize your vacation time with your own reliable vehicle.",
    ],
    image: orlando,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Ottawa",
    description: [
      "Discover Canada's Capital - Welcome to Ottawa. From the historic architecture of Parliament Hill to the vibrant stalls of the ByWard Market, this city is best seen on your own terms. Whether you are here for government business or a winter getaway, having your own set of wheels makes all the difference.",
      "Our fleet features executive sedans for navigating the city in style, and rugged vehicles perfect for a weekend road trip to Gatineau Park. Whether you are skating the Rideau Canal or driving out to explore Ontario’s history, we have the perfect rental for your capital adventure.",
    ],
    image: ottawa,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Denver",
    description: [
      "Explore the Mile High City & Beyond - Welcome to Denver, the Mile High City—where urban energy meets mountain adventure. Whether you're navigating downtown's craft breweries and cultural attractions or heading out to Red Rocks Amphitheatre, our car rental Denver services make exploration seamless.",
      "Our fleet is purpose-built for Colorado terrain. We offer rugged options for renting a Jeep in Denver to handle off-road exploration, or a spacious family SUV for a ski trip to Vail or Breckenridge. Experience the freedom to create your own mountain itinerary, from the city streets to Rocky Mountain National Park.",
    ],
    image: denver,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Atlanta",
    description: [
      "Cruising the Peachtree City - Welcome to Atlanta, the bustling heart of the south. Whether you are catching a game at the stadium, closing deals in Buckhead, or visiting the World of Coca-Cola, you need a vehicle that can keep up with the pace. Welcome to the Peachtree City, where our rentals help you move with the rhythm of the A.",
      "Select a fuel-efficient sedan for navigating the city traffic, or grab a comfortable SUV for a road trip to the Blue Ridge Mountains. We bring you the trusted service Aombre is known for, ensuring your drive across Georgia is as smooth as southern hospitality.",
    ],
    image: atlanta,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Vancouver",
    description: [
      "Where Ocean Meets Mountain - Welcome to Vancouver, the jewel of the West Coast. From the urban forests of Stanley Park to the trendy streets of Gastown, this city is a playground for nature lovers and city slickers alike. Our car rental Vancouver service gives you the freedom to cruise the coastline or head for the hills.",
      "Pick up a compact car for zipping around downtown, or choose a powerful SUV for the breathtaking drive along the Sea-to-Sky Highway toward Whistler. Whether you're catching a ferry to the islands or exploring the North Shore mountains, start your Pacific adventure with the right vehicle.",
    ],
    image: vancouver,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Montreal",
    description: [
      "Experience European Flair in North America - Welcome to Montreal, a city of culture, festivals, and joie de vivre. Whether you are exploring the cobblestone streets of Old Montreal, enjoying the nightlife on Crescent Street, or visiting the iconic Mount Royal, a rental car lets you experience the city's unique charm without limits.",
      "Our fleet offers stylish sedans perfect for city dining and business trips, as well as comfortable vehicles for a weekend getaway to the Laurentians or Mont-Tremblant. Skip the metro and drive in comfort as you discover the vibrant art, history, and cuisine of Quebec.",
    ],
    image: montreal,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Chicago",
    description: [
      "Drive the Windy City - Welcome to Chicago, home of iconic architecture and deep-dish pizza. Whether you are shopping the Magnificent Mile, attending meetings in The Loop, or taking in the views at Navy Pier, getting around is easier on your own schedule. Our car rental Chicago service helps you navigate the Midwest metropolis with ease.",
      "Select a premium sedan for a smooth ride down Lake Shore Drive, or a spacious SUV to handle the city winters and family trips. From the bustle of downtown to the charm of the suburbs, explore everything Chicagoland has to offer from the comfort of your own driver's seat.",
    ],
    image: chicago,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
  {
    heading: "Car Rental in",
    prefix: "Now",
    title: "Calgary",
    description: [
      "Gateway to the Rockies - Welcome to Calgary, the heart of the New West. Whether you are here for the world-famous Stampede, business in the energy sector, or simply passing through, our rental service gets you moving. Experience the perfect blend of prairie hospitality and mountain adventure.",
      "Our fleet includes rugged SUVs and trucks ideal for the short drive to Banff National Park and Lake Louise. Don't be limited by tour bus schedules—grab the keys and explore the majestic Canadian Rockies or the vibrant city center at your own pace.",
    ],
    image: calgary,
    description2:
      "Book Now and hit the road with aombre.com | Your Journey Starts Here.",
  },
];
const News = () => {
  const navigate = useNavigate();
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: (dots) => (
      <div>
        <ul className="flex justify-center space-x-2 mt-2 !m-0 p-0">{dots}</ul>
      </div>
    ),

    customPaging: (i) => (
      <button
        className="w-2.5 h-2.5 rounded-full !m-0 !p-0"
        style={{
          backgroundColor: "#EDEBEC",
        }}
      />
    ),
  };

  return (
    <>
      <div className="w-full mx-auto px-2 py-6 bg-[#006039] md:pt-12 md:pb-12">
        <h1
          className="flex items-center justify-center  pt-6 
        relative text-2xl sm:text-3xl md:text-4xl lg:text-4xl text-center text-[#EDEBEC] font-semibold inline-block"
        >
          New Locations
        </h1>

        <p className="text-sm flex items-center justify-center text-[#edebec] font-semibold p-2 ">
          We’re Expanding to Serve you Better{" "}
        </p>

        <Slider {...settings}>
          {locations.map((location, index) => (
            <div className="pt-6 px-1" key={index}>
              <div className="max-w-7xl mx-auto  flex flex-col md:flex-row items-stretch w-full h-full md:h-[500px] overflow-hidden rounded-2xl border border-[#EDEBEC] ">
                <div className="w-full md:w-1/2 h-[230px] md:h-full">
                  <img
                    src={location.image}
                    alt={location.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="w-full md:w-1/2 flex items-center justify-center p-8 text-center md:text-left bg-[#edebec] ">
                  <div>
                    <p className="inline-flex items-center gap-2 px-3 py-1 mb-4 rounded-full text-[#CA8032] bg-[rgba(202,128,50,0.1)] text-sm font-medium">
                      {location.prefix} open in{" "}
                      <span className="text-[#ca8032]">{location.title}</span>
                    </p>
                    
                    <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-[#353535] mb-4">
                     {location.heading} {" "}
                      <span className="text-[#ca8032]">{location.title}</span>
                    </h2>

                    {/* <p className="text-[#353535] text-md leading-relaxed">
                      {location.description}
                    </p> */}
                    {/* --- START OF CHANGED SECTION --- */}
                    {/* This checks if it's an array and maps it, otherwise behaves normally */}
                    {Array.isArray(location.description) ? (
                      location.description.map((paragraph, index) => (
                        <p
                          key={index}
                          className="text-[#353535] text-md leading-relaxed mb-4" // Added mb-4 for spacing
                        >
                          {paragraph}
                        </p>
                      ))
                    ) : (
                      // Fallback in case description is still a string
                      <p className="text-[#353535] text-md leading-relaxed">
                        {location.description}
                      </p>
                    )}
                    <br></br>
                    {/* <p className="text-[#353535] text-md leading-relaxed">
                      Book Now and hit the road with{" "}
                      <a
                        href="https://aombre.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#ca8032] underline hover:text-blue-800"
                      >
                        aombre.com
                      </a>{" "}
                      - Your Journey Starts Here.
                    </p> */}
                    <div className="flex flex-col sm:flex-row gap-4">
                <button
                  size="lg"
                  className="rounded-xl h-14 px-8 text-lg text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
                  style={{ backgroundColor: "#006039" }}
                  onClick={() => navigate("/vehicles")}
                >
                  Search Cars
                </button>
                <button
                  size="lg"
                  variant="outline"
                  className="h-14 px-8 text-lg border-2 rounded-xl"
                  style={{ borderColor: "#CA8032", color: "#CA8032" }}
                   onClick={() => navigate("/locations")}
                >
                  View Locations
                </button>
              </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <style>
          {`
  /* Remove Slick's default pseudo-element */
  .slick-dots li button:before {
    content: none !important;
  }

  /* Active dot color and size */
  .slick-dots li.slick-active button {
    background-color: #ca8032 !important;
  }

  /* Make all dots same size */
  .slick-dots li button {
  
    width: 8px !important;
    height: 8px !important;
    border-radius: 9999px !important;
    padding: 0 !important;
    margin: 6px !important;
  }
`}
        </style>
      </div>
    </>
  );
};

export default News;
